import clsx from 'clsx';

import { openNewWindow } from '@/lib/webview';

const LinkTextAlign = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const;
export type LinkTextAlign = typeof LinkTextAlign[keyof typeof LinkTextAlign];

export type LinkTextProps = {
  text: string;
  href: string;
  align: LinkTextAlign;
};

export const LinkText = ({ text, href, align }: LinkTextProps) => {
  const mode = (() => {
    switch (align) {
      case LinkTextAlign.Center:
        return 'text-center';
      case LinkTextAlign.Left:
        return 'text-left';
      case LinkTextAlign.Right:
        return 'text-right';
      default:
        return '';
    }
  })();
  return (
    <div>
      <button
        type="button"
        className={clsx('py-[0.75rem] px-3 text-blue underline hover:text-blue-d1', `${mode}`)}
        onClick={() => openNewWindow(href)}
      >
        {text}
      </button>
    </div>
  );
};
